export const apiServiceTypeEnum = {
  APPLICATION: 'app', // 应用服务
  TOOLKIT: 'tk', // 工具服务
  INFRA: 'inf' // 基础服务
}
